module.exports = __webpack_public_path__ + "img/數據分析.7b4fb586.svg";